import { path } from 'd3-path';
import { ReadableElement } from '../base/readable-element';
import { RotationDirectionType } from '../../model/shared/rotation/rotation-direction-type';
import { calculatePercent, degreesToRadians } from '../shared/math-utils';
import { VariableUtil } from '../../utils/variable-util';
import { VariableDefinition } from '../../communication/variable/variable-definition';
export class RingGraphElement extends ReadableElement {
    get readVariableName() {
        if (!this.model.variableId) {
            return '';
        }
        const variable = new VariableDefinition(this.model.variableId.variableName.name, this.model.variableId.variableName.groupName, this.model.variableId.dataSourceCode, this.model.variableId.variableName.variableVersion);
        return VariableUtil.getConvertedVariableName(this.variableStore, variable);
    }
    constructor(element, permissionChecker, variableCommunicator, variableStore, localization) {
        super(element, permissionChecker, variableCommunicator, variableStore, localization);
        const el$ = $(element);
        this._barElement$ = el$.find('path[data-id="barArc"]');
        this._textElement$ = el$.find('text[data-id="pText"]');
        setTimeout(() => {
            this.initFrameNode();
            this.changeStates();
        }, 0);
    }
    initFrameNode() {
        const arcPath = Snap(this.$element[0]);
        const b = arcPath.getBBox(true);
        this.rootElement.append('rect').attr('id', 'StateFrame').attr('width', b.width).attr('height', b.height).attr('fill', 'transparent');
    }
    updateVariableValue(value) {
        const percent = calculatePercent(this.model.min, this.model.max, value);
        this.updateBar(percent);
        this._barElement$.attr('fill', this.getBarColor(value));
        if (this.model.showPercentage) {
            this._textElement$.text((percent * 100).toFixed(0) + '%');
        }
    }
    updateBar(percent) {
        const model = this.model;
        const outer = model.size.width / 2.0;
        const rawStartAngle = model.arc.startAngle;
        const rawEndAngle = model.arc.endAngle;
        const sweepAngle = rawStartAngle === rawEndAngle ? 360 :
            (rawStartAngle < rawEndAngle ? rawEndAngle - rawStartAngle : rawEndAngle + 360 - rawStartAngle);
        const scale = model.scale;
        const inner = outer * (scale / 100.0);
        const arcPath = path();
        switch (Number(model.direction)) {
            case RotationDirectionType.ClockWise:
                this.drawClockWiseArc(rawStartAngle, sweepAngle, percent, arcPath, outer, inner);
                break;
            case RotationDirectionType.ReverseClockWise:
                this.drawAntiClockWiseArc(rawEndAngle, sweepAngle, percent, arcPath, outer, inner);
                break;
        }
        arcPath.closePath();
        this._barElement$.attr('d', arcPath.toString());
    }
    getBarColor(value) {
        const model = this.model;
        if (!model.enableAlarmRange) {
            return model.barFill;
        }
        const alarmRange = model.alarmRange;
        if (value > alarmRange.upper) {
            return alarmRange.upperFill;
        }
        else if (value < alarmRange.lower) {
            return alarmRange.lowerFill;
        }
        else {
            return model.barFill;
        }
    }
    drawClockWiseArc(rawStartAngle, sweepAngle, percent, arcPath, outer, inner) {
        const startRadians = degreesToRadians(rawStartAngle);
        const endAngle = sweepAngle * percent + rawStartAngle;
        const endRadians = degreesToRadians(endAngle);
        arcPath.arc(outer, outer, outer, startRadians, endRadians);
        arcPath.arc(outer, outer, inner, endRadians, startRadians, true);
    }
    drawAntiClockWiseArc(rawEndAngle, sweepAngle, percent, arcPath, outer, inner) {
        const startRadians = degreesToRadians(rawEndAngle);
        const endAngle = rawEndAngle - sweepAngle * percent;
        const endRadians = degreesToRadians(endAngle);
        arcPath.arc(outer, outer, outer, startRadians, endRadians, true);
        arcPath.arc(outer, outer, inner, endRadians, startRadians);
    }
}
